// extracted by mini-css-extract-plugin
export var card = "_m7-0";
export var content = "_m7-2";
export var details = "_m7-3";
export var icon = "_m7-1";
export var iconBlue = "_m7-5";
export var iconBrand = "_m7-4";
export var iconGrayBlue = "_m7-6";
export var iconGreen = "_m7-7";
export var iconIndigo = "_m7-8";
export var iconOrange = "_m7-9";
export var iconPurple = "_m7-a";
export var iconRed = "_m7-b";
export var iconWarning = "_m7-c";